import { cn } from "@/utils";
import { Button } from "@mantine/core";
import { QueryErrorResetBoundary } from "@tanstack/react-query";
import { t } from "i18next";
import { LucideAlertTriangle } from "lucide-react";
import { startTransition } from "react";

export function ErrorState({
  resourceType,
  reset,
  className,
  size = "md",
  hideIcon = false,
}: {
  resourceType?:
    | "trip"
    | "trips"
    | "trips.create"
    | "trips.edit"
    | "reservation"
    | "reservations"
    | "clients"
    | "client"
    | "employees"
    | "employee"
    | "role"
    | "roles"
    | "analytics"
    | "finance.ledger"
    | "finance"
    | "auditLog"
    | "payments"
    | "agency"
    | "discountCodes"
    | "discountCode"
    | "withdrawal"
    | "withdrawals";
  hideIcon?: boolean;
  reset?: () => void;
  className?: string;
  size?: "sm" | "md";
}) {
  return (
    <QueryErrorResetBoundary>
      {({ reset: resetQuery }) => (
        <div
          className={cn(
            "flex grow flex-col items-center justify-center rounded-lg text-center",
            size === "sm"
              ? "min-h-75 p-md"
              : "min-h-100 border border-dashed p-xl",
            className,
          )}
        >
          {!hideIcon ? (
            <div
              className={cn(
                "bg-red-light mx-auto mb-md flex items-center justify-center rounded-full",
                size === "sm" ? "size-12" : "size-16",
              )}
            >
              <LucideAlertTriangle
                className={cn(
                  "text-red-filled",
                  size === "sm" ? "size-6" : "size-8",
                )}
              />
            </div>
          ) : null}
          <h3
            className={cn(
              "text-red-light-color mt-1.5 font-semibold",
              size === "sm" ? "text-lg" : "text-xl",
            )}
          >
            {t("error.title")}
          </h3>
          <p
            className={cn("text-text", size === "sm" ? "text-sm" : "text-base")}
          >
            {t(
              resourceType
                ? `${resourceType}.error.description`
                : "error.description",
            )}
          </p>
          <Button
            onClick={() =>
              startTransition(() => {
                resetQuery();
                reset?.();
              })
            }
            className="mt-lg"
          >
            {t("tryAgain")}
          </Button>
        </div>
      )}
    </QueryErrorResetBoundary>
  );
}
